import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useExperimentalFeatures } from 'hooks/useExperimentalFeatures'
import { useIsPrimerPayPalEnabled } from 'hooks/useIsPrimerPayPalEnabled'

import { PaymentMethod } from 'modules/purchase/constants'
import { selectAvailablePaymentMethods } from 'modules/purchase/redux/selects/common'

export const useDisplayedAlternativeMethods = () => {
  const availableAlternativePaymentMethods = useSelector(
    selectAvailablePaymentMethods,
  )
  const { isAyah61PwSpeedTest } = useExperimentalFeatures()
  const isPrimerPayPalAvailable = useIsPrimerPayPalEnabled()

  return useMemo(() => {
    const hasPayPalMethod = availableAlternativePaymentMethods.includes(
      PaymentMethod.PAYPAL,
    )
    const shouldOptimisticallyShowPayPal =
      isAyah61PwSpeedTest && isPrimerPayPalAvailable && !hasPayPalMethod
    const shouldShowPayPalByCountry =
      !isAyah61PwSpeedTest && isPrimerPayPalAvailable && !hasPayPalMethod

    return shouldOptimisticallyShowPayPal || shouldShowPayPalByCountry
      ? [...availableAlternativePaymentMethods, PaymentMethod.PAYPAL]
      : availableAlternativePaymentMethods
  }, [
    availableAlternativePaymentMethods,
    isAyah61PwSpeedTest,
    isPrimerPayPalAvailable,
  ])
}
